import { Layout } from 'antd'
import { useState, type ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { PageBreadcrumb } from './PageBreadcrumb'
import { OnboardingTour } from './OnboardingTour'
import { NLPAssistant } from './NLPAssistant'

const { Content } = Layout

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <Layout className="h-screen">
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout>
        <Header />
        <Content className="overflow-auto">
          <div className="px-6 pt-4">
            <PageBreadcrumb />
          </div>
          <div className="p-6 pt-4">{children}</div>
        </Content>
      </Layout>
      <OnboardingTour />
      <NLPAssistant />
    </Layout>
  )
}
